import {createAction, createSlice} from '@reduxjs/toolkit';

const initialState = {
  token: '',
  refreshToken: '',
  userName: '',
  password: '',
  userDetails: {},
  hasActiveSub: false,
  hasExistingSub: false,
  existingSubDetails: [],
  currentSubDetails: {},
  isLoading: false,
};

export const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    setBearerToken: (state, action) => {
      state.token = action.payload;
    },
    setUserName: (state, action) => {
      state.userName = action.payload;
    },
    setPasswordState: (state, action) => {
      state.password = action.payload;
    },
    setRefreshToken: (state, action) => {
      state.refreshToken = action.payload;
    },
    setUserDetails: (state, action) => {
      state.userDetails = action.payload;
    },
    setActiveSub: (state, action) => {
      state.hasActiveSub = action.payload;
    },
    setExistingSub: (state, action) => {
      state.hasExistingSub = action.payload;
    },
    setCurrentSubDetails: (state, action) => {
      state.currentSubDetails = action.payload;
    },
    setExistingSubDetails: (state, action) => {
      let temp = [...state.existingSubDetails];
      temp.push(action.payload);
      state.existingSubDetails = temp;
    },
    resetExistingSub: (state, action) => {
      state.existingSubDetails = [];
    },
    resetUserState: (state, action) => {
      return initialState;
    },
    setLoading: (state, action) => {
      state.isLoading = action.payload;
    },
  },
});

export const {
  setBearerToken,
  setRefreshToken,
  setUserName,
  setUserDetails,
  setActiveSub,
  setPasswordState,
  setCurrentSubDetails,
  setExistingSubDetails,
  resetUserState,
  setExistingSub,
  setLoading,
  resetExistingSub,
} = userSlice.actions;

export default userSlice.reducer;
